<template>
  <div class="width:100%">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in courses" :key="item._id">
            <td>{{ item.name }}</td>
            <td class="text-right">
              <v-btn icon="">
                <v-icon small class="" @click="showAnalytics(item)">
                  mdi-eye
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import services from "@/services";
// import services from "@/services";
export default {
  data() {
    return {
      courses: []
    };
  },
  methods: {
    showAnalytics(item) {
      this.$router.push({
        name: "course-analytics",
        params: { courseid: item._id }
      });
    },
    async onLoad() {
      try {
        let courses = await services.course.get({
          status: "published",
          type: "publisher"
        });
        this.courses = courses;
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style></style>
